import { Box, Typography } from "@mui/material";
import { USAddress } from "baptize-america-client";
import { formatAddress } from "../utils/helper";

const CustomAddress = ({
  address,
  boxStyle,
}: {
  address: USAddress | undefined;
  boxStyle?: any;
}) => {
  if (address === undefined || address?.streetAddress1 === undefined)
    return null;

  return (
    <Box sx={boxStyle ? boxStyle : null}>
      <Typography sx={{ whiteSpace: "pre-line", textAlign: "right" }}>
        {formatAddress(address, true)}
      </Typography>
    </Box>
  );
};

export default CustomAddress;
